import { render, staticRenderFns } from "./CandidateRowTask.vue?vue&type=template&id=0c9141a1&scoped=true&lang=pug"
import script from "./CandidateRowTask.vue?vue&type=script&lang=js"
export * from "./CandidateRowTask.vue?vue&type=script&lang=js"
import style0 from "./CandidateRowTask.vue?vue&type=style&index=0&id=0c9141a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9141a1",
  null
  
)

export default component.exports